import React, { useState, useEffect } from "react";
import RightArrow from "../../../../../assets/images/RightArrow@2x.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../CustomComponents/Loader";
import CustomDatePicker from "../../../../CustomComponents/CustomDateInput";
import { width } from "../../../../CustomComponents/DynamicCard/DynamicCardStyles";
import CustomTextInput from "../../../../CustomComponents/CustomtextInput";
import DynamicCard from "../../../../CustomComponents/DynamicCard";
import {
  appTheme,
  decimalValidation,
} from "../../../../../helpers/utils/Utils";
import {
  addLineBreaks,
  handleAmountInputLimitTo2decimal,
  handleAmountInputLimitTo2decimalForAmount,
  retrieveData,
} from "../../../../../utils";
import logFirebaseEvents from "../../../../LogFirebaseEvents";
import CardHeading from "../../../../CustomComponents/CardHeading";
import { withOidcSecure } from "@axa-fr/react-oidc";
import {
  ADD_SAVING_GOALS_V2,
  SAVING_CARD_CODE,
  STATUS_SUCCESS_CODE,
} from "../../../../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  PostRequest,
} from "../../../../../network/NetworkUtils";
import CustomRadioButtonGroup from "../../../../CustomComponents/CustomRadioButton";
import checkbox_fill from "../../../../../assets/images/Checkbox-blue.png"
import SavingGoalSubItemConfirmationCard from "../SavingGoalSubItemConfirmationCard";
import moment from 'moment'
const styleForbuttons = "md:mr-[20px]"
 
const SavingGoalConfirmation = ({
  cardFooter,
  onBack,
  onNext,
  handleAmountInput,
  onSave,
  onSetSpendSenseAlertFun,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [amountError, setAmountError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const amount = useSelector((state) => state.savingGoals.amount);
  const name = useSelector((state) => state.savingGoals.name);
  const selectedTargetDate = useSelector((state) => state.savingGoals.targetDate);
  const NotificationTypeSMS = useSelector((state) => state.savingGoals.sms);
  const NotificationTypeEmail = useSelector((state) => state.savingGoals.email);
  const [NotificationError, setNotificationError] = useState('')
  const [responseMsg, setResponseMsg] = useState();
  const [activeIndex, setActiveIndex] = useState(-1);
  const [notificationArray, setNotificationArray] = useState([{ displayText: t('text'), isSelected: NotificationTypeSMS }, { displayText: t('email'), isSelected: NotificationTypeEmail }])
  const targetDate=((new Date(selectedTargetDate).getDate() - new Date(new Date().toUTCString().substr(0, 25)).getDate()) === 1) ? moment(selectedTargetDate).format('[Tomorrow], dddd, MMMM DD, YYYY') : moment(selectedTargetDate).format('dddd, MMMM DD, YYYY') 
 
 

  const handleBackClick = () => {
    logFirebaseEvents(
      "Saving_Goals",
      "Back_Saving_Goals_Clicked",
      "Back_Saving_Goals_Clicked",
      "",
      ""
    );
    onBack("SavingGoalNotificationField");
  };
 
  const handleSaveClick = async () => {
    logFirebaseEvents(
      "Saving_Goals",
      "Next_Saving_Goals_Clicked",
      "Next_Saving_Goals_Clicked",
      "",
      ""
    );
    if (!amount) setAmountError("Amount Required");
    if (amount && !amountError);
    const savingsAccount = cards.find(
      (account) => account.AccountTypeBit63 == SAVING_CARD_CODE
    );
    const url = ADD_SAVING_GOALS_V2(savingsAccount.CardKey);
    const requestObject = {
      goalName: name,
      targetAmount: amount,
      isSms: NotificationTypeSMS,
      isEmail: NotificationTypeEmail,
    };
     if (selectedTargetDate != undefined)
     {
      requestObject.targetDate=moment(selectedTargetDate).format('YYYY-MM-DD')
     }
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    try {
      setIsLoading(true);
      const response = await PostRequest(url, requestObject, headers);
      const responseJson = JSON.parse(response);
      setIsLoading(false);
      setResponseMsg(responseJson);
 
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        dispatch({
          type: "SAVING_GOAL_RESPONSE_DATA",
          payload: { savingGoalResponseData: responseJson.Response },
        });
        onSave("success");
      } else {
        var arrMessages = responseJson.Messages;
        var message = arrMessages[0];
        var displayText = message.MessageOrField;
        if (displayText === "GoalNameExist") {
          onSave("existedName");
        } else {
          var arrMessages = responseJson.Messages;
          var message = arrMessages[0];
          var displayText = message.DisplayText;
 
          dispatch({
            type: "SAVING_GOAL_RESPONSE_MSG",
            payload: { savingGoalResonseMsg: displayText },
          });
          onSave("error");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  const onEdit1 = (value, type, index) => {  
  
    setActiveIndex(index);  
  };
 
 
  const setNotificationFun = (option) => {
    setNotificationError('');
    const selectedIndex = notificationArray.findIndex(
      (item) => item.displayText === option.displayText
    );
    notificationArray[selectedIndex] = { ...option, 'isSelected': !option?.isSelected }
    setNotificationArray([...notificationArray])
    if (option.displayText == "Email") {
      dispatch({
        type: 'SAVING_GOALS',
        payload: { 'key': 'email', 'value': !option?.isSelected }
      });
    } else {
      dispatch({
        type: 'SAVING_GOALS',
        payload: { 'key': 'sms', 'value': !option?.isSelected }
      });
 
    }
  }
 
  const onDateChange = (date) => {
    dispatch({ type: 'SAVING_GOALS', payload: { 'key': "targetDate", 'value': date } })
  }
 
  const datas = [
    {
      title: "savings goal",
      value: name,
      edit: "Edit Savings Goal Name",
      onEdit: () => onEdit1(name, "SavingGoalName", 1),
      type: "name",
    },
    {
      title: "Target Amount",
      value: `$${amount}`,
      edit: "Edit Amount",
      onEdit: () => onEdit1(amount, "SavingGoalAmount", 2),
      type: "amount",
    },
  ];
 
  const amountValidation = () => {
    if (!amount) setAmountError("amount Required");
    else if (amount <= 0) {
      setAmountError("Please enter amount greater than 0");
    } else if (
      (amount || "").endsWith(".") ||
      (amount.includes(".") && amount.split(".")[1].length < 2)
    ) {
      setIsNext(false);
    } else {
      setAmountError(null);
      setIsNext(true);
    }
  };
  useEffect(() => {
    if (amount) amountValidation();
    if (!amount) setIsNext(false);
  }, [amount]);


  const [isEditingStates, setIsEditingStates] = useState([]);

  const handleSetIsEditingState = (index, isEditing) => {
    const updatedStates = [...isEditingStates];
    updatedStates[index] = isEditing;
    setIsEditingStates(updatedStates);
  };

  const isAnyItemEditing = isEditingStates.some((state) => state === true);

  
 
  const children = () => {
    return (
      <>
        {/* {cardHeader} */}
 
        <div
          className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
                 sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
                      text-[var(--Great-Add-Spendsense)] mt-6 sm:mx-0 mx-4 sm:flex sm:flex-col "
        >
          <span>{t("Set_Saving_Goal_Preview")} </span>
          <span
            className="text-[var(--matter-add-spendSense)] lg:w-[590px] md:w-[590px] sm:w-[358px]
                  w-[264px]"
          >
            {addLineBreaks(t("Set_Saving_Goal_For_Preview"))}
          </span>
        </div>
 
        <div className="w-full flex justify-center">
          <div className="sm:w-[80%] w-full">
            {/* BODY */}
            <div className="md:my-16 sm:my-10 mb-12 sm:mx-0 mx-4">
 
              <div className="sm:w-[80%] w-full flex flex-col justify-center">
              {datas &&
                  datas.map((data, index) => {
                    return (
                      <SavingGoalSubItemConfirmationCard
                        key={index}
                        data={data}
                        onEdit={() => data.onEdit()}  
                        isActive={activeIndex === index}  
                        setIsEditingState={(isEditing) => handleSetIsEditingState(index, isEditing)}
                      />
                    )
                  })
                }
                 <div className="md:mt-12 sm:mt-10 mt-12">
                  <CustomDatePicker
                    selectedDate={selectedTargetDate}
                    onDateChange={(date) => onDateChange(date)}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                    // minDate={new Date()}
                    // maxDate={''}
                    placeHolder={t('Month_Day_Year')}
                    disabledDates={[]}
                    title="target Date"
                    hrbg="bg-dropdown-sky"
                  />
                </div>
                <div className='mt-10 md:w-[63%]'>
                  {/* <div className='lg:py-20 md:py-10 sm:py-10 py-12'> */}
                  <CustomRadioButtonGroup
                    title={t('spending_alert_notification_title')}
                    options={notificationArray}
                    onSelect={setNotificationFun}
                    fillIcon={checkbox_fill}
                    nullIcon={appThemeData.isBatCheck}
                    error={NotificationError}
                  />
 
                    <p className='mt-4 font-hanken-grotesk text-[var(--notify-type-clr)] 
                    text-[12px] leading-[30px] 
                    font-normal'>{t('standard_message')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER */}
 
        {cardFooter(handleBackClick, handleSaveClick, false, `${t("save")}`, !isAnyItemEditing,styleForbuttons)}
      </>
    );
  };
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--cardHeading-bg"}
        HeaderContent={
          <>
            <CardHeading heading={t("Add_Saving_Goal")} />
          </>
        }
        footer={true}
      >
        {children()}
      </DynamicCard>
 
      {isLoading && <Loader />}
    </>
  );
};
 
export default withOidcSecure(SavingGoalConfirmation);